import { render } from "./SectionHero.vue?vue&type=template&id=36e48d66&scoped=true"
import script from "./SectionHero.vue?vue&type=script&lang=js"
export * from "./SectionHero.vue?vue&type=script&lang=js"

import "./SectionHero.vue?vue&type=style&index=0&id=36e48d66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e48d66"]])

export default __exports__